document.addEventListener("DOMContentLoaded", function() {
  const canvas = document.getElementById("sig-canvas");
  if (!canvas) return;
 
  const ctx = canvas.getContext("2d");
  ctx.strokeStyle = "#222";
  ctx.lineWidth = 2;
 
  let drawing = false;
  let hasSignature = false;
 
  // Get mouse/touch position
  function getPos(e) {
    const rect = canvas.getBoundingClientRect();
    const touch = e.touches ? e.touches[0] : e;
    return { x: touch.clientX - rect.left, y: touch.clientY - rect.top };
  }
 
  function start(e) {
    drawing = true;
    const pos = getPos(e);
    ctx.beginPath();
    ctx.moveTo(pos.x, pos.y);
    e.preventDefault();
  }
 
  function draw(e) {
    if (!drawing) return;
    const pos = getPos(e);
    ctx.lineTo(pos.x, pos.y);
    ctx.stroke();
    hasSignature = true;
    e.preventDefault();
  }
 
  function stop() { drawing = false; }
 
  // Mouse events
  canvas.addEventListener("mousedown", start);
  canvas.addEventListener("mousemove", draw);
  canvas.addEventListener("mouseup", stop);
  // Touch events
  canvas.addEventListener("touchstart", start);
  canvas.addEventListener("touchmove", draw);
  canvas.addEventListener("touchend", stop);
 
  // Clear button
  document.getElementById("sig-clearBtn").addEventListener("click", function () {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    hasSignature = false;
    document.getElementById("signatureData").value = "";
    document.getElementById("signatureError").style.display = "none";
  });
 
  // Form reference
  const form = canvas.closest("form");
  if (!form) return;
 
  // 1️⃣ Override form.submit() for programmatic submits
  const originalSubmit = form.submit;
  form.submit = function() {
    if (!hasSignature) {
      document.getElementById("signatureError").style.display = "block";
      canvas.scrollIntoView({ behavior: "smooth", block: "center" });
      return false; // block submission
    }
    document.getElementById("signatureData").value = canvas.toDataURL("image/png");
    return originalSubmit.apply(form, arguments);
  };
 
  // 2️⃣ Catch submit button click (AJAX submit)
  form.addEventListener("click", function(e) {
    if (e.target.type === "submit") {
      if (!hasSignature) {
        e.preventDefault();
        document.getElementById("signatureError").style.display = "block";
        canvas.scrollIntoView({ behavior: "smooth", block: "center" });
        return false;
      }
    }

     const data = canvas.toDataURL("image/png");
    document.getElementById("signatureData").value = data;

    const agreementText = document.querySelector(
      ".rich-text__text"
    ).innerText;
   console.log('agreementText',agreementText);
  

    // send signature AFTER submit
    setTimeout(() => {
     fetch("/apps/signature-handler?source=register", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: document.getElementById("RegisterForm-email").value,
          signature: data,
          agreement : agreementText
        })
      });
    }, 1000);
  });
});